export enum SearchResultsFilterName {
  SearchTerm = 'searchTerm',
  StoryTypes = 'storyTypes',
  NewsTypes = 'newsTypes',
  ResearchTypes = 'researchTypes',
}
